
const lenis = new Lenis();

function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
}
requestAnimationFrame(raf);

gsap.set("#targetImg", { scale: 1 });

// コンセプト部分Js
const mm = gsap.matchMedia();

mm.add("(min-width: 768px)", () => {

    gsap.to(".layer", {
        opacity: 0.15,
        ease: "none",
        scrollTrigger: {
            trigger: ".concept_content_wrap",
            start: "top top",
            end: "+=70%",
            scrub: true
        }
    });

});

mm.add("(max-width: 767.99px)", () => {
    gsap.to(".layer", {
        opacity: 0.15,
        ease: "none",
        scrollTrigger: {
            trigger: ".concept_content_wrap",
            start: "top top",
            end: "+=70%",
            scrub: true
        }
    });


});
// トップ動画制御

const controlBtn = document.getElementById("controlBtn");
const video = document.querySelector(".main__wrap--mv video");
const image = document.querySelector(".main__wrap--mv .mv-end-img");

let isTransitioning = false; // フェード中フラグ

// 初期状態
controlBtn.textContent = "Skip";
image.style.opacity = 0;
image.style.display = "none";

// 動画終了時に画像へ切り替え
video.addEventListener("ended", () => {
    if (!isTransitioning) skipVideo();
});

// ボタンクリックで再生制御
controlBtn.addEventListener("click", () => {
    if (isTransitioning) return; // フェード中は無視

    if (video.paused || video.classList.contains("is-hidden")) {
        replayVideo();
    } else {
        skipVideo();
    }
});

// Skip：動画をフェードアウトして停止し、画像を表示
function skipVideo() {
    isTransitioning = true;
    fadeOut(video, () => {
        video.pause();
        video.classList.add("is-hidden");
        video.style.display = "none"; // ← ここを追加
        fadeIn(image, () => {
            image.classList.add("is-active");
            controlBtn.textContent = "Replay";
            isTransitioning = false;
        });
    });
}

// Replay：画像をフェードアウト → 動画を再生
function replayVideo() {
    isTransitioning = true;
    fadeOut(image, () => {
        image.classList.remove("is-active");
        image.style.display = "none";
        video.currentTime = 0;
        video.classList.remove("is-hidden");
        video.style.display = "block";
        fadeIn(video, () => {
            video.play();
            controlBtn.textContent = "Skip";
            isTransitioning = false;
        });
    });
}

// フェード関数
function fadeOut(el, callback) {
    el.style.transition = "opacity 0.8s ease";
    el.style.opacity = 1;
    requestAnimationFrame(() => {
        el.style.opacity = 0;
        setTimeout(() => {
            if (typeof callback === "function") callback();
        }, 800);
    });
}

function fadeIn(el, callback) {
    el.style.transition = "opacity 0.8s ease";
    el.style.display = "block";
    el.style.opacity = 0;
    requestAnimationFrame(() => {
        el.style.opacity = 1;
        setTimeout(() => {
            if (typeof callback === "function") callback();
        }, 800);
    });
}

// const listArea = document.querySelector('.news_list');
// const list = document.querySelectorAll('.news_item');
// const listBox = document.querySelector('.news_box');

// list.forEach((list) => {
//     for (let i = 0; i < 2; i++) {
//         const li = document.createElement("li");
//         li.innerHTML = list.innerHTML;
//         li.classList.add('news_item');
//         listBox?.appendChild(li);
//     }

//     const ul = document.createElement('ul');
//     ul.innerHTML = listBox?.innerHTML;
//     ul.classList.add('news_box');
//     listArea?.appendChild(ul);
// })


$(document).ready(function () {
    $('#water').ripples({ //波紋をつける要素を指定
        resolution: 300, //波紋が広がる速さ
        dropRadius: 20, //波紋の大きさ
        perturbance: 0.01 //波紋の揺れの量
    });
});


document.querySelectorAll('.loc_img').forEach(container => {
    const video = container.querySelector('video');

    // --- PCのホバー処理 ---
    container.addEventListener('mouseenter', () => {
        video.play();
    });

    container.addEventListener('mouseleave', () => {
        video.pause();
        video.currentTime = 0; // 再生位置をリセットする場合
    });

    // --- SPのタップ処理 ---
    container.addEventListener('touchstart', (e) => {
        // 他の再生中の動画を止める（1つだけ再生させたい場合）
        document.querySelectorAll('.loc_img').forEach(other => {
            if (other !== container) {
                other.classList.remove('is-playing');
                other.querySelector('video').pause();
            }
        });

        // クラスを切り替えて再生/停止
        if (container.classList.contains('is-playing')) {
            container.classList.remove('is-playing');
            video.pause();
        } else {
            container.classList.add('is-playing');
            video.play();
        }
    }, { passive: true });
});